import styled from 'styled-components';
import { lineHeight } from '../style';

export const BasicHeader = styled.h2`
  margin: 0 0 ${lineHeight}px 0;
  font-size: 1em;
`;
